import DirectionsCarOutlinedIcon from '@mui/icons-material/DirectionsCarOutlined'

export const VehicleIcon = DirectionsCarOutlinedIcon
export default VehicleIcon
